import { LOGIN, LOGOUT, NULL_USER } from "../actions/action.types";

export default (state, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        user: action.payload.user,
        isLoggedIn: true,
        loading: false
      };
    case LOGOUT: {
      return { user: undefined, isLoggedIn: false, loading: false };
    }
    case NULL_USER: {
      return { user: undefined, isLoggedIn: false, loading: false };
    }
    default:
      return state;
  }
};
